import { Target } from '../interfaces';

export default function (target?: Target): boolean {
    return target === Target.SERVER || target === Target.BOTH;
}
